import React from 'react';
import JsonInspector from 'react-json-inspector';
import 'react-json-inspector/json-inspector.css';
import './json-tree.scss';
export default class JsonTree extends React.Component {
    onChange(keypath) {
        return (newValue) => {
            // tslint:disable-next-line:no-console
            console.log('json-tree onChange', keypath, newValue);
            if (this.props.onChange) {
                this.props.onChange(keypath, newValue);
            }
        };
    }
    render() {
        return (React.createElement(JsonInspector, { data: this.props.data }));
    }
}
